import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowPdfComponent } from './show-pdf/show-pdf.component';
import { QrPdfComponent } from './qr-pdf/qr-pdf.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { QRCodeModule } from 'angularx-qrcode';

import { NgxPrintModule } from 'ngx-print';
import { QrCodeGeneratorComponent } from './qr-code-generator/qr-code-generator.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslationLoaderFactory } from '@monorepo/services';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
@NgModule({
  imports: [
    CommonModule,
    PdfViewerModule,
    QRCodeModule,
    NgxPrintModule,
    FormsModule,
    IonicModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          const factory = new TranslationLoaderFactory(http);
          return factory.createForApp('ui');
        },
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [ShowPdfComponent, QrPdfComponent, QrCodeGeneratorComponent],
  exports: [ShowPdfComponent, QrPdfComponent, QrCodeGeneratorComponent],
})
export class PdfModule {}
